
export default {
  props: [],
  data() {
    return {
        activeItem: '',
        listItem: [
            '用地规划与发展',
            '产业信息',
            '工改政策解读',
            '“工业上楼”案例',
            '房地产市场情况',
            '经济可行性测算',
            '项目总结',
            '公司介绍',
            '即将完成'
        ],
        upload: null,
        animation: null,
        pathPause: null,
        pathRepeat: 'M4.5,4.5 C6.4,2.6 9.6,2.6 11.5,4.5 C12.2,5.2 12.7,6.2 12.9,7.2 L14.9,6.9 C14.7,5.4 14,4.1 13,3.1 C10.3,0.4 5.9,0.4 3.1,3.1 L0.9,0.9 L0.2,7.3 L6.6,6.6 L4.5,4.5 Z'
    }
  },
  mounted() {   
               
  },
  computed: {    
  },
  methods: {
    completeAnimation() {
        this.upload.addClass('finished');        
        this.upload.find('.percent span').animate({            
            width: 20
        }, 400);
        this.upload.find('.percent span').css({overflow: 'initial'})   
        $('#finishLoading').hide() 
        $('#uploadContainer').fadeOut() 
        this.activeItem = ''       
    },
    fail() {
        $('#uploadContainer').hide()
    },
    fakeUpload(duration) {
        this.activeItem = this.listItem[0]
        this.$nextTick( () => {
            $('#uploadContainer').show()
            this.upload = $('.upload')
            let that = this
            this.animation = $({
                num: 0
            })
            .animate({
                num: 100
            },
            {
                duration: duration,
                easing: 'linear',
                step() {                                
                    that.upload[0].style.setProperty('--percent', Math.floor(this.num));
                    let seconds = Math.floor((duration - duration * this.num / 100) / 1000) + 1
                    that.upload.find('[data-seconds]').text(seconds);
                    if (seconds > 0 && seconds < 30) {
                        that.activeItem = that.listItem[0]
                    } else if (seconds > 30 && seconds < 60) {
                        that.activeItem = that.listItem[1]
                    } else if (seconds > 60 && seconds < 90) {
                        that.activeItem = that.listItem[2]
                    }else if (seconds > 90 && seconds < 110) {
                        that.activeItem = that.listItem[3]
                    }else if (seconds > 110 && seconds < 130) {
                        that.activeItem = that.listItem[4]
                    }else if (seconds > 130 && seconds < 150) {
                        that.activeItem = that.listItem[5]
                    }else if (seconds > 150 && seconds < 170) {
                        that.activeItem = that.listItem[6]
                    }else if (seconds > 170 && seconds < 180) {
                        that.activeItem = that.listItem[7]
                    } else if (seconds > 180) {
                        that.activeItem = that.listItem[8]
                    } 
                    
                },
                complete() {
                    that.upload[0].style.setProperty('--percent', Math.floor(this.num));
                    that.completeAnimation();
                }
            });
        })
        
    }

  }
}
